module.exports = __webpack_public_path__ + "static/media/Inter-Italic.c4d61b7a.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Inter/Inter-Italic.woff
// module id = 691
// module chunks = 21